import React, { useState, useEffect } from "react";
import axios from "axios";
import configuration from "../Utility/config.json";
const hub_url = process.env.REACT_APP_HUB_URL;
const TipoCategoriaCatastale = ({ token, onChangeCategoria }) => {
  const [selectedValue, setSelectedValue] = useState("");
  const [categoriaCatastaleOptions, setCategoriaCatastaleOptions] = useState(
    []
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getCategoriaCatastale = async () => {
    try {
      const config = {
        method: "GET",
        url: hub_url + configuration.HUB_PATH_GET_CATEGORIE_CATASTALI, // Sostituisci con l'URL corretto
        headers: {
          Authorization: `Bearer ${token}`, // Usa il token per l'autenticazione
        },
      };

      const response = await axios(config);

      if (response.status !== 200) {
        throw new Error("Errore nel recupero delle categorie catastali");
      }

      const options = Array.isArray(response.data)
        ? response.data.map((categoriaCatastale) => {
            if (categoriaCatastale.gruppo && categoriaCatastale.categorie) {
              return {
                gruppo: categoriaCatastale.gruppo,
                categorie: categoriaCatastale.categorie,
              };
            } else {
              console.warn(
                "Oggetto mancante di gruppo o categorie:",
                categoriaCatastale
              );
              return {}; // ritorna un oggetto vuoto se manca uno dei due
            }
          })
        : []; // Se response.data non è un array, ritorna un array vuoto

      setCategoriaCatastaleOptions(options);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategoriaCatastale();
  }, [token]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    onChangeCategoria(event.target.value);
  };

  if (loading) {
    return <div>Caricamento...</div>;
  }

  if (error) {
    return <div>Errore: {error}</div>;
  }

  if (
    !Array.isArray(categoriaCatastaleOptions) ||
    categoriaCatastaleOptions.length === 0
  ) {
    return <div>Nessuna categoria disponibile</div>; // Aggiungi un messaggio se le opzioni sono vuote
  }

  return (
    <div>
      <label htmlFor="categoriaCatastale">Categoria Catastale*:</label>
      <select
        id="categoriaCatastale"
        name="categoriaCatastale"
        value={selectedValue}
        onChange={handleChange}
        disabled={categoriaCatastaleOptions.length === 0}
      >
        <option value="">Seleziona una categoria catastale</option>
        {categoriaCatastaleOptions.map((categoriaCatastale, index) => (
          <optgroup key={index} label={categoriaCatastale.gruppo}>
            {categoriaCatastale.categorie.map((categoria) => (
              <option key={categoria.id} value={categoria.id}>
                {categoria.codice}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
    </div>
  );
};

export default TipoCategoriaCatastale;
